import { PropsWithChildren } from 'react';
import { VideoPlayerProvider } from '../../contexts/videoPlayer';
import * as UI from './styles';

const VideoTemplate = ({ children }: PropsWithChildren<any>) => {
    return (
        <UI.Container>
            <VideoPlayerProvider>
                {children}
            </VideoPlayerProvider>
        </UI.Container>
    );
}

export default VideoTemplate;